/**
 * Support Page - Customer service for all businesses
 */

import React from 'react';

const Support: React.FC = () => {
  return (
    <div>
      <h1 style={styles.title}>Customer Support</h1>
      <p style={styles.subtitle}>Help businesses on the platform</p>
      
      <div style={styles.card}>
        <p>Support ticket system - Coming soon</p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#fff',
    margin: 0,
  },
  subtitle: {
    color: '#9ca3af',
    marginTop: '5px',
  },
  card: {
    background: '#1a1a2e',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #252540',
    marginTop: '20px',
  },
};

export default Support;
